import React from 'react';
import '../LoginNew.css';  // Create this CSS file for styling
import logo from '../assets/down_icon.png'; // Adjust path as needed

const LoginNew = () => {
  return (
    <div className="login-container">
        <div className="login-card">
            <div className="login-header">
                <h1 style={{margin:' 38px auto 30px', textAlign:' left', width:'80%'}}>Login</h1>
            </div>
            <div className="login-body">
                <form>
                    <div className="input-group">
                        <input type="email" placeholder="Email" required=""/>
                    </div>
                    <div className="input-group">
                        <input type="password" placeholder="Password" required=""/>
                    </div>
                    <button type="submit" className="btn-signin">Sign in</button>
                </form>
                <a href="/forgot-password" className="forgot-password">Forgot Password?</a>
                <button className="btn-create-account">Create Account</button>
            </div>
        </div>
    </div>
  );
}

export default LoginNew;
